import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { reportingUnit, address, time, type, unit, total },
} = checkout;

const validations = Yup.object().shape({
  [reportingUnit.name]: Yup.string().required(reportingUnit.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [unit.name]: Yup.string().required(unit.errorMsg),
  [time.name]: Yup.date().required(time.errorMsg),
  [type.name]: Yup.string().required(type.errorMsg),
  [total.name]: Yup.number().required(total.errorMsg),
});

export default validations;
